








































































import { portalApi } from '../../api/api';
import { Component, Prop, Provide, Vue } from "vue-property-decorator";

@Component({})
export default class indexPage extends Vue {
  // @Prop() private msg!: string;
  public msg: string = '12';
  public banner:any= [
    {url: require('../../../static/images/banner.png'),title: 'AISWare AIRPA', subtitle: '拒绝重复低效，拥抱智能创造，引领企业数智化转型',
    describe: 'AISware AIRPA，即亚信机器人流程自动化平台，与传统实体机器人不同，主要用于信息化系统的自动化操作，在对现有系统非侵入的方式下提供数据采集、数据搬运、数据填写、流程执行、注智赋能、流程再造等能力，实现业务流程自动化、智能化，激发企业业务内生活力，助力企业数智化转型。'},
    // {url: require('../../../static/images/banner_1.png'),title: 'AISWare AIRPA', subtitle: '拒绝重复低效，拥抱智能创造，引领企业数智化转型',
    // describe: 'AISware AIRPA，即亚信机器人流程自动化平台，与传统实体机器人不同，主要用于信息化系统的自动化操作，在对现有系统非侵入的方式下提供数据采集、数据搬运、数据填写、流程执行、注智赋能、流程再造等能力，实现业务流程自动化、智能化，激发企业业务内生活力，助力企业数智化转型。'}
  ];
  public excellent:any = [
    {image: require('../../assets/images/index/index_1.svg'), title: '集成AI及大数据能力安全', describe: '大数据能力注智，融合AI感知技术，拓展自动化的广度和深度，提升智能化程度，以最少的人工干预完成任务处理，实现长期效益'},
    {image: require('../../assets/images/index/index_2.svg'), title: '低成本，高回报', describe: '企业使用AIRPA可实现有效提升工作效率约75%、节约成本超过80%，可实现400%投资回报率'},
    {image: require('../../assets/images/index/index_3.svg'), title: '流程智能', describe: '构建拖拽式流程设计平台，组装浏览器，Windows，Office等操作组件，实现可视化流程设计'},
    {image: require('../../assets/images/index/index_4.svg'), title: '可视化流程机器人制作', describe: '企业享有应用开发的版权，可通过应用授权，在企业内部合理共享应用，实现体系化应用分发'},
    {image: require('../../assets/images/index/index_5.svg'), title: '高级增值服务', describe: '我们提供专业的培训与技术支持，提供现场实施，可根据企业需求进行流程机器人场景定制化开发'},
    {image: require('../../assets/images/index/index_6.svg'), title: '轻量化交付', describe: '产品轻量化设计，对部署资源需求量极少，机器人管家容器化部署，设计器一键安装，软件交付简单易操作'}
  ];
  public worthList:any = [
    {title: ['推动降本增效','助力解放人力'], 
    list: ['面向重复、高耗时的业务，成本降至原人工执行的1/5-1/9之间，效率提升约5-10倍','实现7*24小时在线，解放人力，推动员工技能升级和价值升华，执行更有创造性的操作'],
    icon: require('../../assets/images/index/value_1.svg')},
    {title: ['操作安全易用','结果准确可靠'], 
    icon: require('../../assets/images/index/value_2.svg'),
    list: ['非侵入式操作，由机器进行敏感数据处理，防止信息泄漏','轻量化部署，快速交付，见效迅速', '避免人工错误操作，提高流程质量以及业务处理的准确性']},
    {title: ['打破业务烟囱','联通数据孤岛'], 
    icon: require('../../assets/images/index/value_3.svg'),
    list: ['实现跨系统的业务流程处理，提升业务处理的连续性，加快业务信息化进程','实现跨系统的数据搬运和处理，加快数据运转速度，提高数据利用效率']},
    {title: ['流程智能化服务','助力企业数智化转型'], 
    icon: require('../../assets/images/index/value_4.svg'),
    list: ['结合AI服务，为流程重塑提供智能化引导，AI算法辅助智能决策','推动智能化流程在企业更好的发挥价值，助力企业数值化转型']},
  ];
  public scene:any = [
    {backImg: require('../../assets/images/index/scene_1.png'),title: '运营商行业',subList: ['IT巡检','合同协议材料审核','定期分析上传数据','5G基站质检'],
    des: '面向运营商行业，可广泛应用于网络优化机器人、IT巡检、政企客户自动建档、合同协议材料审核、客服系统信息采集备份、定期分析上传数据、订单处理、5G基站质检等多个应用场景'},
    {backImg: require('../../assets/images/index/scene_2.png'),title: '政务行业',subList: ['政务自动审批','政务记录自动核查','证照信息自动生成'],
    des: '政务自动审批、信息自动录入、政务记录自动核查、政务服务自动对话机器人、证照信息自动生成等多个应用场景'},
    {backImg: require('../../assets/images/index/scene_3.png'),title: '银行行业',subList: ['客户账户管理','金融索赔处理','客户黑白名单审核'],
    des: '多系统间数据迁移、客户账户管理、自动生成报表、金融索赔处理、客户黑白名单审核、零售贷款、差旅报销、信用卡在线审批、资金结算等多个应用场景'},
    {backImg: require('../../assets/images/index/scene_4.png'),title: '零售行业',subList: ['制造商网站数据提取','网站导入','电子邮件处理'],
    des: '制造商网站数据提取、自动在线库存更新、网站导入、电子邮件处理、订单数据处理、智能客服等多个应用场景'},
    {backImg: require('../../assets/images/index/scene_5.png'),title: '财务行业',subList: ['电子税务办理','研发费用时序帐整合'],
    des: '电子税务办理、差旅报销、研发费用时序账整合、交通费进项抵扣账务处理、加计扣除计提增值税等多个应用场景'},
    {backImg: require('../../assets/images/index/scene_6.png'),title: '人事行业',subList: ['招聘历史核实','薪资自动化','费用管理'],
    des: '寻找候选人、招聘历史核实、招聘和入职及离职、薪资自动化、缺勤管理、费用管理等多个应用场景'}
  ];

  public index: number = 0;
  public backUrl: string = require('../../assets/images/index/scene_1.png');
  public sceneList :any = this.scene[0];

  private click(): void {
      this.$message({ message: '000', type: "warning" });
  }

  sceneLi(num: number){
    this.index = num;
    this.backUrl = this.scene[num].backImg;
    this.sceneList = this.scene[num];
  }

  private great() {
      let data = {
          loginName: 'bing',
          password: 'e10adc3949ba59abbe56e057f20f883e'
      }
      portalApi.login(data).then(res => {
        console.log(res);
      })
  }

  created(){
    
  }

  mounted(){
    // this.great()
  }

}
